import FYCQueryBuilder, { FYCQuery } from "./FYCQueryBuilder";
import type { RouterProps } from "instantsearch.js/es/middlewares/createRouterMiddleware";
import type { IndexUiState, UiState } from "instantsearch.js";
import { buildAlgoliaRouting } from "./routing";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { cruiseSearchIndexName } from "src/algolia";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { useMemo } from "react";

type UseFYCReturnValues = {
  filterDefaultSearch: FYCQuery;
  localizedSearchIndexName: string;
  routing: RouterProps<UiState, IndexUiState>;
};

export function useFYC(initialQuery: FYCQuery | undefined): UseFYCReturnValues {
  const geolocation = useGeolocation();
  const language = useLanguage();
  const localizedSearchIndexName = cruiseSearchIndexName();
  const routing = buildAlgoliaRouting(localizedSearchIndexName, language);

  const filterDefaultSearch = useMemo(() => {
    const queryBuilder = new FYCQueryBuilder(initialQuery);
    queryBuilder
      .onlyFutureCruises()
      .onlyVisibleForCountry(geolocation.countryCode);

    if (process.env.GATSBY_SHOW_ALL_FUTURE_CRUISES != "true")
      queryBuilder.onlyVisibleCruises();
    return queryBuilder.generate();
  }, [geolocation.countryCode, initialQuery]);

  return {
    routing,
    filterDefaultSearch,
    localizedSearchIndexName
  };
}
